import styled from "styled-components";

export const OrderModalWrapper = styled.div`
  background-color: #242526;
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 10px;
  padding: 20px 16px;
`;
